import type { CalibrationRecord } from '@/types/robotEvents'
import { JOINT_LABELS, METHOD_LABELS, describeDelta } from './calibrationFormat'

function formatTime(ts: string): string {
  return new Date(ts).toLocaleTimeString('ja-JP', { hour12: false })
}

interface CalibrationLogTableProps {
  records: CalibrationRecord[]
  truncated?: boolean
  // 行クリックで詳細 (URDF 全文など) を開く
  onSelect?: (record: CalibrationRecord) => void
}

// キャリブレーション画面からの URDF 書き換えを時系列ログとして出す (設定変更タブと同じ粒度)。
// 詳細は CalibrationDetailModal
export default function CalibrationLogTable({
  records,
  truncated,
  onSelect,
}: CalibrationLogTableProps) {
  return (
    <div className="overflow-x-auto">
      {truncated && (
        <p className="px-6 pt-2 text-xs text-amber-600">
          イベント数が多いため一部のみ表示しています
        </p>
      )}
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              時刻
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              対象
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              変更量
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              方法
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {records.map((r) => (
            <tr
              key={r.key}
              className={onSelect ? 'hover:bg-gray-50 cursor-pointer' : ''}
              onClick={() => onSelect?.(r)}
              title="クリックで詳細 (URDF) を表示"
            >
              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                {formatTime(r.ts)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                キャリブレーション: {JOINT_LABELS[r.joint] ?? r.joint}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
                {describeDelta(r.joint, r.before, r.after)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                {(METHOD_LABELS[r.method] ?? r.method) || '－'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
